// Última posição conhecida de cada mídia tocada nesta aba, em segundos.
//
// O progresso salvo na matrícula só anda de quarto em quarto (25/50/75/100%),
// então não devolve o aluno ao ponto exato quando um player é montado de novo.
// A memória mora no módulo, e não em estado React, justamente para sobreviver à
// desmontagem do player. Um reload da página a apaga, e aí vale o progresso
// salvo.

interface IPlaybackMemoryEntry {
  currentTime: number
  isPlaying: boolean
  updatedAt: number
}

export interface IPlaybackStart {
  /** Segundos a partir dos quais o player deve começar. */
  startAt: number
  /** O player foi desmontado com o vídeo tocando: volta tocando. */
  autoplay: boolean
}

// A janela cobre a remontagem do player (spinner, busca das URLs e iframe
// novo), que acontece logo em seguida. Passado disso o aluno saiu da aula e
// voltou: retoma no ponto, mas pausado.
export const PLAYBACK_AUTOPLAY_WINDOW_MS = 5000

const memory = new Map<string, IPlaybackMemoryEntry>()

export function rememberPlayback(
  key: string,
  entry: { currentTime: number; isPlaying: boolean },
  now = Date.now(),
) {
  memory.set(key, { ...entry, updatedAt: now })
}

/**
 * De onde o player deve começar: a posição vista nesta aba, se houver, senão o
 * progresso salvo (`savedTime`), senão o início.
 */
export function resolvePlaybackStart(
  key: string,
  savedTime?: number | null,
  now = Date.now(),
): IPlaybackStart {
  const live = memory.get(key)
  if (live) {
    return {
      startAt: live.currentTime,
      autoplay:
        live.isPlaying && now - live.updatedAt <= PLAYBACK_AUTOPLAY_WINDOW_MS,
    }
  }

  return {
    startAt: savedTime && savedTime > 0 ? savedTime : 0,
    autoplay: false,
  }
}

/** Só para testes. */
export function clearPlaybackMemory() {
  memory.clear()
}
